export const graphThemes = {
  default: ["#3B82F6", "#10B981", "#F59E0B", "#EF4444", "#6366F1", "#EC4899"],
  earthy: ["#A78B71", "#D4A373", "#F4A261", "#E76F51", "#6D6875", "#2A9D8F"],
  pastel: ["#A5B4FC", "#FBCFE8", "#FDBA74", "#86EFAC", "#FDE68A", "#BFDBFE"],
  neon: ["#00F5D4", "#00BBF9", "#F15BB5", "#9B5DE5", "#FEE440", "#FF006E"],
  midnight: ["#0F172A", "#1E293B", "#334155", "#475569", "#64748B", "#CBD5E1"],
};
